import React from 'react'
import { JobsModalsProvider } from './JobsModalsManagerContext'
import JobsBoardContent from './JobsBoardContent'
import { PopsModalsProvider } from 'components/Pop/Modal/PopsModalsManager'
import { CompaignModalsProvider } from '../Compaign/CompaignModalsManagerContext'

const JobsBoard: React.FC = () => {
  return (
    <CompaignModalsProvider>
      <PopsModalsProvider>
        <JobsModalsProvider>
          <JobsBoardContent />
        </JobsModalsProvider>
      </PopsModalsProvider>
    </CompaignModalsProvider>
  )
}

export default JobsBoard
